import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useAdminDeveloperAccessRequestsQuery.ts
var r = (r = 1, i = 25) => t({
	queryKey: e.requests(r, i),
	queryFn: () => n.listRequests({
		page: r,
		pageSize: i
	})
});
//#endregion
export { r as useAdminDeveloperAccessRequestsQuery };
